import 'core-js/actual/promise';
import React from 'react';
import request from "superagent";
import ReactDOM from "react-dom";
import ProgramsForm from "./programs_form";

const context = programContext;


// START
$(() => {
	renderAll();
});


function renderAll() {
	renderForm();
	refreshEvents();
}


window.programsState = {
	'form': {
		// values
		'containerClass': context.formClass,
		'onSelectFieldChange': handleSelectFieldChange,
		'choices': {
			'curriculum_areas': context.curriculum_areas,
			'resource_types': context.resource_types,
			'audiences': context.audiences
		},
		'data': {
			// default values
			'curriculum_areas': context.curriculum_areas_selected,
			'resource_types': context.resource_types_selected,
			'audiences': context.audiences_selected
		}
	},
	'listing': {
		'class': context.listingClass,
		'isLoading': true
	}
};


function refreshEvents() {
	/* Show the events corresponding to the current form */
	/*
	use JSON.stringify on arrays to prevent them from being indexed i.e. something like:
	{'resource_types': ['12','34']}
	is converted to
	{'resource_types[0]': ['12'], 'resource_types[1]': ['34']}
	by the time it reaches the django view. I am yet to identify the root cause of this
	issue. It could be related to updating superagent form 3.x.x to 8.x.x which now uses
	'application/x-www-form-urlencoded' instead of 'application/json'.
	Now using:
	{'resource_types': JSON.stringify(['12','34'])}
	is received by django view as
	{'resource_types': "['12','34']"}
	which is converted back to a list using json.loads
	*/
	programsState.listing.isLoading = true;
	window.get_csrf_token_value().then(csrfToken => {
	request
		.post(`/education-programs-api/`)
		.type('form')
		.send({
			'csrfmiddlewaretoken': csrfToken,
			'curriculum_areas': JSON.stringify(normaliseValue(programsState.form.data.curriculum_areas)),
			'resource_types': JSON.stringify(normaliseValue(programsState.form.data.resource_types)),
			'audiences': JSON.stringify(normaliseValue(programsState.form.data.audiences))
		})
		.then(result => {
			if (result.body.success) {
				$(`.${programsState.listing.class}`).html(result.body.html);
				programsState.listing.isLoading = false;
			}
			else {
				console.log("Incorrect search");
				programsState.listing.isLoading = false;
			}
		})
		.catch(err => {
			console.log(err.message, []);
			programsState.listing.isLoading = false;
		});
	});
}

function normaliseValue(selections){
	if (!selections) {
		return [];
	}
	if (Array.isArray(selections)){
		return selections.map(selection => selection.value);
	}
	return [selections.value || selections];
}


function renderForm() {
	const mount_point = document.getElementsByClassName(programsState.form.containerClass)[0];
	mount_form_component(mount_point);
}


function mount_form_component(mount_point) {
	ReactDOM.render(
		<ProgramsForm programsState={programsState} />,
		mount_point
	);
}


function handleSelectFieldChange(form, fieldName, event) {
	form.data[fieldName] = event;
	updateUrlBasedOnSelection();
	renderAll();
}


function updateUrlBasedOnSelection() {
	let queryString = Object.keys(programsState.form.data).reduce(function (result, key) {
		if (programsState.form.data[key]) {
			programsState.form.data[key].forEach(function (selected_item){
				if (result) {
					result += '&';
				}
				result += key + '=' + selected_item.value;
			});
		}
		return result;
	}, '');

	let url = window.location.pathname + '?' + queryString;
	window.history.replaceState(null, null, url);
}
